/**
 * Webpack shim for @tensorflow/tfjs-backend-webgl.
 *
 * The WebGL backend throws during module init in Expo/webpack builds
 * (CPU_HANDOFF_SIZE_THRESHOLD flag). Web colour analysis uses the CPU backend.
 */
export const version = '0.0.0-shim';
export const version_webgl = '0.0.0-shim';
export const webgl = { forceHalfFloat: () => {} };
